import React from "react";
import { Box, RadioGroup } from "@mui/material";
import { DotLegalHeader, DotLegalRadioButton, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { YesNoNotNecessaryAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";
import { showsIdentityVerificationMethod } from "./incidentLogIdentityVerifiedVisibility.ts";

export interface IncidentLogIdentityVerifiedFieldProps {
    answer?: YesNoNotNecessaryAnswer | null;
    verificationMethod?: string;
    onAnswerChange: (answer: YesNoNotNecessaryAnswer) => void;
    onVerificationMethodChange: (verificationMethod: string) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogIdentityVerifiedField(props: IncidentLogIdentityVerifiedFieldProps) {
    const { translateString } = useTranslation();

    return (
        <>
            {/* Same spacing as IncidentLogYesNoUnknownAnswerField: the DotLegal field below brings its own top margin. */}
            <Box sx={{ mt: 2 }}>
                <DotLegalHeader marginBottom={0} headerStyle={"small"} toolTip={translateString("identityVerifiedHelpText")}>
                    {translateString("identityVerified")}
                </DotLegalHeader>
                <RadioGroup
                    row
                    value={props.answer ?? null}
                    onChange={(e) => props.onAnswerChange(Number((e.target as HTMLInputElement).value) as YesNoNotNecessaryAnswer)}
                >
                    <DotLegalRadioButton value={YesNoNotNecessaryAnswer.Yes} labelPlacement="end" label={translateString("yes")} disabled={props.disabled} />
                    <DotLegalRadioButton value={YesNoNotNecessaryAnswer.No} labelPlacement="end" label={translateString("no")} disabled={props.disabled} />
                    <DotLegalRadioButton
                        value={YesNoNotNecessaryAnswer.NotNecessary}
                        labelPlacement="end"
                        label={translateString("notNecessary")}
                        disabled={props.disabled}
                    />
                </RadioGroup>
                {props.errorText && <Box sx={(theme) => ({ fontSize: theme.typography.pxToRem(12), color: theme.palette.error.main })}>{props.errorText}</Box>}
            </Box>
            {showsIdentityVerificationMethod(props.answer, props.isPreview) && (
                <DotLegalTextField
                    label={translateString("identityVerificationMethod")}
                    value={props.verificationMethod ?? ""}
                    debounce
                    multiline
                    rows={3}
                    onChange={props.onVerificationMethodChange}
                    disabled={props.disabled}
                />
            )}
        </>
    );
}

export default IncidentLogIdentityVerifiedField;
